import { createActions } from '@/utils/actions';

const { actions: bulkEdit } = createActions('bulkEdit')
  .add('addOperation')
  .add('addPendingUpdates')
  .add('addPreview')
  .add('aiDiscard')
  .addAsync('aiOperationGenerate')
  .addAsync('aiPreviewGenerate')
  .add('applyPreview')
  .addAsync('bootstrap')
  .add('closeBulkEdit')
  .addAsync('getCategories')
  .addAsync('getErrorCounts')
  .addAsync('getFilterIds')
  .addAsync('getInvalidProducts')
  .addAsync('getPhotosByIndex')
  .addAsync('getProducts')
  .addAsync('getProfileListings')
  .addAsync('removeBackground')
  .add('removePreview')
  .add('replaceOperation')
  .add('saveAs')
  .addAsync('scheduleUpdates')
  .add('search')
  .add('selectOperation')
  .add('setBanner')
  .add('setFilterByErrors')
  .add('setData')
  .add('setModal')
  .add('setPage')
  .add('setProduct')
  .addAsync('setProfile')
  .addAsync('setSelection')
  .add('selectMenuItem')
  .addAsync('syncUpdates')
  .add('toggleAllProducts')
  .add('toggleProduct')
  .add('updateMenuForCategory')
  .addAsync('setTitlePreference');

export default bulkEdit;
